import { Injectable } from "@angular/core";
import { Prelevement } from "src/app/domain/prelevement";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { ConsommableRepository } from "./consommable.repository";
import { FlaconRepository } from "./flacon.repository";
import { SamplingPointRepository } from "./sampling-point.repository";
import { PrelevementEntity } from "../prelevement.entity";
import { PrelevementQualifSalleEntity } from "../prelevement-qualif-salle.entity";

@Injectable({
    providedIn: 'root',
})
export class PrelevementRepository {

    constructor(
        private flaconRepository: FlaconRepository,
        private samplingPointRepository: SamplingPointRepository,
        private consommableRepository: ConsommableRepository,
    ) { }

    async getPrelevementEntityById(id: number) {
        return await db.prelevements.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getPrelevementById(id: number) {
        return await db.prelevements.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, PrelevementEntity, Prelevement);

            if (ze?.SamplingPointId) {
                z.SamplingPoint = await this.samplingPointRepository.getSamplingPointById(ze?.SamplingPointId)
            }

            if (ze?.FlaconIds) {
                for (let i = 0; i < ze.FlaconIds.length; i++) {
                    z.FlaconList.push(await this.flaconRepository.getFlaconById(ze.FlaconIds[i]));
                }
            }

            if (ze?.ConsommableIds) {
                for (let i = 0; i < ze.ConsommableIds.length; i++) {
                    z.ConsommableList.push(await this.consommableRepository.getConsommableById(ze.ConsommableIds[i]));
                }
            }
            return z;
        });
    }

    async getPrelevementEntityByCode(code: string) {
        return await db.prelevements.where('Code').equals(code).first(async ze => {
            return ze;
        });
    }

    async attachPrelevementToAir(p: Prelevement, paId: number) {
        let pId: number;
        const pe = mapper.map(p, Prelevement, PrelevementEntity);

        // const pae = await this.prelevementAirRepository.getPrelevementAirEntityById(paId);
        pId = await db.prelevements.add(pe);
        await db.prelevementAirs.update(paId, {
            PrelevementId: pId
        });

        if (p.SamplingPoint) {
            await this.samplingPointRepository.attachSamplingPoint(p.SamplingPoint, pId);
        }

        if (p.FlaconList?.length > 0) {
            for (let i = 0; i < p.FlaconList.length; i++) {
                await this.flaconRepository.attachFlacon(p.FlaconList[i], (await this.getPrelevementEntityById(pId))!);
            }
        }
        return pId;
    }

    async attachPrelevementToSurface(p: Prelevement, psId: number) {
        let pId: number;
        const pe = mapper.map(p, Prelevement, PrelevementEntity);

        // const ae = await this.prelevementSurfaceRepository.getPrelevementSurfaceById(psId);
        pId = await db.prelevements.add(pe);
        await db.prelevementSurfaces.update(psId, {
            PrelevementId: pId
        });

        if (p.SamplingPoint) {
            await this.samplingPointRepository.attachSamplingPoint(p.SamplingPoint, pId);
        }
        if (p.FlaconList?.length > 0) {
            for (let i = 0; i < p.FlaconList.length; i++) {
                await this.flaconRepository.attachFlacon(p.FlaconList[i], (await this.getPrelevementEntityById(pId))!);
            }
        }
        return pId;
    }

    async attachPrelevementToGenerateur(p: Prelevement, gId: number) {
        let pId: number;
        const pe = mapper.map(p, Prelevement, PrelevementEntity);

        // const pae = await this.prelevementGenerateurRepository.getPrelevementGenerateurEntityById(gId);
        pId = await db.prelevements.add(pe);
        await db.prelevementGenerateurs.update(gId, {
            PrelevementId: pId
        });

        if (p.SamplingPoint) {
            await this.samplingPointRepository.attachSamplingPoint(p.SamplingPoint, pId);
        }
        if (p.FlaconList?.length > 0) {
            for (let i = 0; i < p.FlaconList.length; i++) {
                await this.flaconRepository.attachFlacon(p.FlaconList[i], (await this.getPrelevementEntityById(pId))!);
            }
        }
        return pId;
    }

    async attachPrelevementToCanal(p: Prelevement, canalId: number) {
        let pId: number;
        const pe = mapper.map(p, Prelevement, PrelevementEntity);

        // const ce = await this.canalRepository.getCanalEntityById(canalId);
        pId = await db.prelevements.add(pe);
        await db.canals.update(canalId, {
            PrelevementId: pId
        });

        if (p.SamplingPoint) {
            await this.samplingPointRepository.attachSamplingPoint(p.SamplingPoint, pId);
        }
        if (p.FlaconList?.length > 0) {
            for (let i = 0; i < p.FlaconList.length; i++) {
                await this.flaconRepository.attachFlacon(p.FlaconList[i], (await this.getPrelevementEntityById(pId))!);
            }
        }
        return pId;
    }

    async attachPrelevementToQualifSalle(p: Prelevement, prelevementQualifSalleEntity: PrelevementQualifSalleEntity) {
        let pId: number;
        const pe = mapper.map(p, Prelevement, PrelevementEntity);

        // const ce = await this.appareilRepository.getAppareilEntityById(appId);
        pe.Id = await db.prelevements.add(pe);
        await db.prelevementQualifSalles.update(prelevementQualifSalleEntity.Id!, {
            PrelevementId: pe.Id
        });

        if (p.SamplingPoint) {
            await this.samplingPointRepository.attachSamplingPoint(p.SamplingPoint, pe.Id);
        }

        return pe.Id;
    }


    async clearBarCodeInPrelevement(prel: Prelevement) {
        let pe = await this.getPrelevementEntityByCode(prel.Code)
        // CLEAR DB
        if (pe && pe.FlaconIds) {
            for (let i = 0; i < pe.FlaconIds.length; i++) {
                this.flaconRepository.clearBarCode(pe.FlaconIds[i]);
            }
        }

        // CLEAR DOMAIN
        if (prel.FlaconList?.length > 0) {
            for (let i = 0; i < prel.FlaconList.length; i++) {
                prel.FlaconList[i].Barcode = ''
            }
        }
    }
}